module.exports = __webpack_public_path__ + "img/d1.e5257b5f.png";